import { FreeBetMaxPayoutPopUp, isMobile, MaxWinPopup } from '@pascal/pascal-core';
import { gameStore } from '../../../store';
import logo from '../../../assets/images/pascal/logo-pascal.png';
import mask from '../../../assets/images/pascal/game-mask.png';
import { GamePart } from '../../../containers/common/gamePart';

export const GamePartWrapper = () => {
  const { allGameTypes } = gameStore;
  return (
    <div className='game-center-top'>
      <div className='pascal-game-wrp'>
        <div className='pascal-game-holder'>
          {!isMobile() ? (
            <>
              <div className='logo-wrp'>
                <img src={logo} alt='logo' />
              </div>
            </>
          ) : null}
          <div className='game-mask'>
            <img src={mask} alt='mask' />
          </div>
          <div className='pascal-game-inside'>
            {allGameTypes.map((gameTypeId) => (
              <GamePart key={gameTypeId} gameTypeId={gameTypeId} />
            ))}
          </div>
        </div>
      </div>

      <MaxWinPopup />
      <FreeBetMaxPayoutPopUp />
    </div>
  );
};
